exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-components-speedText-___SpeedText__speedValue___iuNFo {\n  align-self: center;\n  font-family: 'Noto Sans';\n}", ""]);

// exports
exports.locals = {
	"speedValue": "src-components-speedText-___SpeedText__speedValue___iuNFo"
};